import { getValue, isPending } from 'mobx-async'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter, OptionsProps } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'

import { SeasonsStore } from '@/_new/domains/finance/stores/SeasonsStore'

interface SeasonGroupFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _SeasonGroupFilter: FC<SeasonGroupFilterProps> = props => {
  const { seasonGroupsOptions } = SeasonsStore

  const seasonGroups = getValue(seasonGroupsOptions)
  const isLoading = isPending(seasonGroupsOptions)

  const formattedSeasonGroupOptions =
    (seasonGroups?.map(seasonGroup => ({
      ...seasonGroup,
      hasFullWidth: true,
    })) as OptionsProps<string>[]) || []

  return (
    <CheckboxBasedFilter
      title="Season Groups"
      isSearchEnabled
      searchPlaceholder="Search by season group"
      isLoadingOptions={isLoading}
      options={formattedSeasonGroupOptions}
      {...props}
    />
  )
}
export const SeasonGroupFilter = observer(_SeasonGroupFilter)
